import { Component } from 'react';
import PropTypes from "prop-types";
import { Link, Route, Routes } from "react-router-dom";

// Helpers.
import Helmet from "react-helmet";

// Constants.
import { DATA_INITIALISING, DATA_LOADED, DATA_LOADING } from "../../../../component/Constants";

// APis
import IntegrationsApi from "../../../../api/Integrations";

//Types
import IntegrationType from "../../../../types/integration/IntegrationType";

// Components.
import Breadcrumb from "../../../../container/breadcrumb";
import HeaderActions from "../../../../container/header_actions";
import ConditionalRender from "../../../../helpers/ConditionalRender";

import List from "./List";
import Detail from "./Detail";


interface WebhooksProps {
    toggleMenu: Function,
    applyPeriod: Function,
    isAdmin: boolean
}

interface WebhooksState {
    loading: number,
    webhooks: IntegrationType[],
}

const initialState = {
    loading: DATA_INITIALISING,
    webhooks: []
}

class Webhooks extends Component<WebhooksProps, WebhooksState> {
    static propTypes: { toggleMenu: PropTypes.Validator<(...args: any[]) => any>, applyPeriod: PropTypes.Validator<(...args: any[]) => any>, isAdmin: PropTypes.Validator<boolean>; };

    constructor(props: WebhooksProps) {
        super(props);

        this.state = initialState;
    };

    async getData() {
        const webhooks = await IntegrationsApi.getIntegrationData('webhook');
        this.setState({
            loading: DATA_LOADED,
            webhooks
        });
    }

    componentDidMount() {
        const { loading } = this.state;

        if (loading === DATA_INITIALISING) {

            this.setState({
                loading: DATA_LOADING
            });

            this.getData();
        }
    }

    /* Action Methods */
    refresh = () => {

        this.setState({
            loading: DATA_LOADING
        });

        this.getData();
    }

    render() {
        const { loading, webhooks } = this.state;

        return (
            <div id="content">
                <Helmet>
                    <title>Webhooks - Settings - DBmarlin</title>
                    <meta name="description" content="Manage Webhooks"/>
                </Helmet>

                <div id="top-header-wrapper" className="row row-cols-2">
                    <Breadcrumb heading="Webhooks">
                        <Link to="/admin">Settings</Link>
                        <Link to="/admin/integrations">Integrations</Link>
                        <span>Webhooks</span>
                    </Breadcrumb>
                    <HeaderActions toggleMenu={this.props.toggleMenu} refresh={this.refresh}
                                   applyPeriod={this.props.applyPeriod}/>
                </div>

                <div className="loader">
                    <ConditionalRender if={false}>
                        <div className="bar"/>
                    </ConditionalRender>
                </div>

                <div className="row row-cols-1">
                    <Routes>
                        <Route path="/:actionId" element={<Detail refresh={this.refresh} webhooks={webhooks} isAdmin={this.props.isAdmin} />}/>
                        <Route path="/" element={<List loading={loading} webhooks={webhooks} refresh={this.refresh} isAdmin={this.props.isAdmin}/>}/>
                    </Routes>
                </div>
            </div>
        )
    }
}

Webhooks.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    applyPeriod: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired
};

export default Webhooks;

